export default __webpack_public_path__ + "static/media/sortDown.017a4a03.svg";